var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "9744216F-DF55-4A93-BD06-07F7D74FB5FD")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AssetSheet",
    transform: "translate(-628.000000, -513.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-2-Copy",
    transform: "translate(628.000000, 513.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05,15.6422616 C7.53,15.6515616 8.99,15.3672616 10.36,14.8059616 C11.73,14.2446616 12.97,13.4174616 14.02,12.3722616 C15.06,11.3271616 15.89,10.0849616 16.45,8.71766162 C17.01,7.35036162 17.29,5.88526162 17.29,4.40726162 C17.29,4.23226162 17.29,4.06596162 17.29,3.89096162 C18.05,3.32966162 18.71,2.63986162 19.24,1.85226162 C18.52,2.16776162 17.76,2.37706162 16.98,2.47346162 C17.81,1.97976162 18.43,1.20266162 18.73,0.285961621 C17.96,0.749261621 17.11,1.07496162 16.23,1.24846162 C15.63,0.614461621 14.84,0.194161621 13.99,0.0526616215 C13.13,-0.0887383785 12.25,0.0564616215 11.48,0.465961621 C10.71,0.875361621 10.1,1.52626162 9.74,2.31776162 C9.38,3.10936162 9.29,3.99746162 9.49,4.84476162 C7.92,4.76766162 6.38,4.36086162 4.98,3.65076162 C3.58,2.94076162 2.34,1.94326162 1.35,0.723461621 C0.85,1.59076162 0.7,2.61556162 0.93,3.59026162 C1.15,4.56506162 1.74,5.41696162 2.58,5.97346162 C1.96,5.94986162 1.36,5.78196162 0.83,5.48346162 L0.83,5.52726162 C0.82,6.43356162 1.13,7.31446162 1.69,8.02296162 C2.26,8.73146162 3.05,9.22496162 3.93,9.42096162 C3.36,9.57446162 2.76,9.59846162 2.18,9.49096162 C2.44,10.2639616 2.93,10.9387616 3.58,11.4227616 C4.24,11.9068616 5.03,12.1764616 5.84,12.1947616 C4.45,13.3151616 2.72,13.9319616 0.93,13.9447616 C0.62,13.9356616 0.31,13.9093616 0,13.8659616 C1.8,15.0182616 3.91,15.6257616 6.05,15.6159616",
    id: "Path"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.5132a4e0.svg";
export { ForwardRef as ReactComponent };